import { derived, writable, type Writable } from "svelte/store";
import translations from "./translation";
import { languageMapping } from "../data-views/options";


// Get laguage from URL and set it as a cookie
const regex = /\/([a-zA-Z]{2})\//; // Regex to match language code (2 letters between slashes)
const matches = document.URL.match(regex);

// If the URL contains a language code, set it as a cookie
if (matches) {
  let language = matches[1];
  document.cookie = `visitory_language=${language}; path=/; max-age=31536000; SameSite=None; Secure;`; 
}

// Grab the user's preferred language from the browser if exists.
const storedlanguage = document.cookie.split('; ').find(row => row.startsWith('visitory_language'))?.split('=')[1];
const parsedLanguage = storedlanguage && languageMapping[storedlanguage] ? languageMapping[storedlanguage] : 'en-US';

export const locale: Writable<string> = writable(parsedLanguage);
export const locales: string[] = Object.keys(translations);

function translate(locale: string, key: string, vars: TranslationVars): string {
  // Let's throw some errors if we're trying to use keys/locales that don't exist.
  // We could improve this by using Typescript and/or fallback values.
  if (!key) console.warn("no key provided to $t()");
  if (!locale) console.warn(`no translation for key "${key}"`);

  // Grab the translation from the translations object.
  let text: string | undefined = translations[locale][key];

  if (!text) {
    console.warn(`no translation found for ${locale}.${key}`);
    return key
  }


  // Replace any passed in variables in the translation string.
  Object.keys(vars).map((k) => {
    const regex = new RegExp(`{{${k}}}`, "g");
    text = text!.replace(regex, vars[k]);
  });

  return text!;
}

// function to find the key of a value in a dictionary
export function findKeyByValue<T>(dictionary: { [key: string]: T }, targetValue: T): string {
  for (let key in dictionary) {
    if (dictionary.hasOwnProperty(key) && dictionary[key] === targetValue) {
      // Since May has a real short form in other languages, we need to return only "May" for "May_short
      if (key === "May_short") return "May";
      return key;
    }
  }
  console.warn(`no key found for value "${targetValue}"`);
  return ""; // Return null if the value is not found in the dictionary
}

export type TranslationVars = Record<string, string>;

export const t = derived(locale, ($locale) => (key: string, vars: TranslationVars = {}): string =>
  translate($locale, key, vars)
);